// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"124":"4b096a8a","242":"220f8caa","710":"e9a683bb","718":"8b7eadbd","787":"d26f6bc8","841":"0e9a0f89","995":"8c8d89f5"}[chunkId] + ".chunk.css";
};